import {useLanguage} from '@/hooks';
import {ErrorMessage} from '@/models';
import {createResponseErrorMessage} from '@/services';

export const onUploadError = response => {
  const { t, PREFIX } = useLanguage();
  if (response) throw createResponseErrorMessage(response);
  else throw new ErrorMessage({ content: t('uploadFailed', PREFIX.ERROR) });
};
